module.exports = __webpack_public_path__ + "img/cx.a4343636.svg";